import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux';
import 'leaflet/dist/leaflet.css';
import { GoogleMapsProvider } from './Components/GoogleMapsProvider';
import './i18n';
import { applyTheme, getStoredTheme } from './utils/theme';
import ThemeProvider from './Components/ThemeProvider';

applyTheme(getStoredTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
  <GoogleMapsProvider>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </GoogleMapsProvider>
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

